import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useUser } from 'shared/hooks/api/user';

function usePostHogIdentify(): void {
  const { data: user } = useUser();
  const posthog = usePostHog();

  useEffect(() => {
    if (!user?.email) return;

    posthog.alias(user.email);
    posthog.identify(user.email, {
      id: user.id,
      email: user.email,
      is_demo: user.is_demo,
      scopes: user.scopes.map((scope) => scope.full_scope),
      company: user.organization.name,
      job_title: user.member.job_title,
      language: user.language,
      site: user.member.site,
    });
    posthog.group('company', user.organization.id, {
      name: user.organization.name,
    });
  }, [user, posthog]);
}

export default usePostHogIdentify;
